export const CHAT_TEXT = {
  typingFallback: 'Generating your OPTAVIA insights',
  emptyResponseFallback: 'No response received',
  errorResponseFallback: 'Sorry, I encountered an error. Please try again.',
  unapprovedResponseFallback:
    'Something went wrong, Please try again or try in a new chat.',

  deleteThreadTitle: 'Delete conversation',
  deleteThreadMessage: 'This will remove the thread from your chat history.',
  cancel: 'Cancel',
  delete: 'Delete',

  supportReferenceTitle: 'Support reference',
  supportReferenceUnavailableMessage:
    'A support reference will be available after the assistant responds in this conversation.',

  deleteAllThreadsTitle: 'Delete all conversations',
  deleteAllThreadsMessage:
    'This will remove all threads from your chat history.',
  deleteAll: 'Delete all',

  title: 'Coach Assistant',
  infoAccessibilityLabel: 'About Coach Assistant',
  beta: 'Beta',
  refreshDataAvailableShort: 'Last Synced',
  hideHistory: 'Hide history',
  showHistory: 'History',
  toggleConversationHistoryAccessibilityLabel: 'Toggle conversation history',
  closeChatAccessibilityLabel: 'Close chat',
  newChat: 'New chat',
  copySupportReferenceAccessibilityLabel: 'Copy support reference',
  supportReferenceLabelPrefix: 'Reference ID ',
  startNewConversationAccessibilityLabel: 'Start new conversation',
  newConversation: '+ New Chat',

  infoHeading: 'Coach Assistant',
  infoBody:
    'Get fast, personalized insights across Orders, Ranks, Commissions, and Bonuses. Ask about your own performance, team trends, and recent progress in one place.',

  loadingHistory: 'Loading conversation history...',
  welcomeHeading: 'Hi! How can I help?',
  welcomeSubtitle:
    'Tap a suggestion below or type your question about your coaching business.',
  placeholder: 'Ask about clients, orders, commissions...',
  sendMessageAccessibilityLabel: 'Send message',
  aiDisclaimer:
    'Coach Assistant is AI and can make mistakes. Please double-check responses.',

  feedbackHelpfulAccessibilityLabel: 'This response was helpful',
  feedbackNotHelpfulAccessibilityLabel: 'This response was not helpful',

  deleteAllConversationsAccessibilityLabel: 'Delete all conversations',
  historyEmptyTitle: 'No chat history yet',
  historyRetentionTitle: 'History',
  historyRetentionMessage: 'You can view conversations from the last 7 days.',
  historyUnavailableMessage:
    'Start a new chat or ask a question to get started.',
  startNewChatFromEmptyStateAccessibilityLabel:
    'Start new chat from history empty state',
  newConversationCta: 'Start New Chat',
  renamePlaceholder: 'Rename',
  save: 'Save',
} as const;

export const getAskAboutSuggestionAccessibilityLabel = (
  label: string,
): string => `Ask about ${label}`;

export const getSendSuggestionAccessibilityLabel = (
  suggestion: string,
): string => `Send suggestion ${suggestion}`;

export const getOpenConversationAccessibilityLabel = (title: string): string =>
  `Open conversation ${title}`;

export const getDeleteConversationAccessibilityLabel = (
  title: string,
): string => `Delete conversation ${title}`;
